module.exports = __webpack_public_path__ + "static/media/loaderTransaparent.3dcde172.gif";